var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "info",
        size: "xl",
        title: "Інформація по коду ЄДРПОУ з сервісу VKURSI",
        centered: "",
        scrollable: "",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n            Close Modal\n        ")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.modalShow,
        callback: function ($$v) {
          _vm.modalShow = $$v
        },
        expression: "modalShow",
      },
    },
    [
      _c(
        "div",
        { staticClass: "company_info" },
        [
          _c(
            "span",
            [
              _c(
                "b-button",
                {
                  staticClass: "mb-2 mt-2",
                  attrs: { variant: "outline-primary" },
                  on: { click: _vm.update_item },
                },
                [_vm._v("Оновити інформацію")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-overlay", { attrs: { show: this.is_update } }, [
            _vm.rows.hasOwnProperty("udata")
              ? _c("span", [
                  _c("span", [_vm._v(" Дата оновлення:")]),
                  _vm._v(" " + _vm._s(_vm.rows.date) + " "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.rows.hasOwnProperty("udata")
              ? _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle.collapse-a",
                                            modifiers: { "collapse-a": true },
                                          },
                                        ],
                                        attrs: {
                                          block: "",
                                          variant: "success",
                                        },
                                      },
                                      [
                                        _vm._v("Загальна інформація "),
                                        _vm.chk_info
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-exclamation-triangle",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-card-text",
                                  [
                                    _c(
                                      "b-collapse",
                                      {
                                        staticClass: "mt-2",
                                        attrs: {
                                          visible: "",
                                          id: "collapse-a",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-list-group",
                                          [
                                            _vm.rows.udata.companyshort
                                              ? _c("b-list-group-item", [
                                                  _c("span", [
                                                    _vm._v("Коротка назва:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.rows.udata
                                                          .companyshort
                                                      ) +
                                                      "\t"
                                                  ),
                                                ])
                                              : _c("b-list-group-item", [
                                                  _c("span", [
                                                    _vm._v("Коротка назва:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.rows.udata.company
                                                      ) +
                                                      "\t"
                                                  ),
                                                ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [_vm._v("ЄРДПОУ:")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.rows.edrpou) +
                                                  "\t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Організаційно-правова форма:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.olf_name
                                                  ) +
                                                  "\t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_status
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [_vm._v("Статус:")]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.state_text
                                                    ) +
                                                    "\t"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_create
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Дата державної реєстрації:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("moment")(
                                                        _vm.rows.udata
                                                          .registration_date
                                                      )
                                                    ) +
                                                    "\t"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_calital
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Розмір статутного капіталу:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.authorised_capital
                                                        .toString()
                                                        .replace(
                                                          /\B(?=(\d{3})+(?!\d))/g,
                                                          " "
                                                        )
                                                    ) +
                                                    " грн.\t"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v("Адреса реєстрації:"),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.address
                                                  ) +
                                                  "\t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Основний вид діяльності згідно КВЕД:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata
                                                      .primary_activity_kind
                                                  ) +
                                                  "\t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v("Ліцензії, дозволи:"),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.licenses
                                                  ) +
                                                  "\t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_employers
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість персоналу:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.employers
                                                        .num_employers
                                                    ) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.rows.udata.employers
                                                        .year
                                                    ) +
                                                    " рік)\t"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [_vm._v("Керівник:")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.chiefCurrent
                                                  ) +
                                                  " \t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Кінцевий бенефіціар(и):"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.beneficiaries
                                                  ) +
                                                  " \t"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    _vm.rows.udata
                                                      .termination != null
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Відомості про припинення/реорганізацію юр особи:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.termination
                                                    ) +
                                                    " \t"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    _vm.rows.udata.bankruptcy !=
                                                    null
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Відомості про банкрутство:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.bankruptcy
                                                    ) +
                                                    " \t"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    _vm.rows.udata.sanctions !=
                                                    "False"
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Зв'язки із компаніями під санкціями:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.sanctions
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Участь у державних тендерах:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.rows.udata.tenders)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_borgZP
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Заборгованість по заробітній платі:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .debtorsBorgZP.borg
                                                    ) +
                                                    "грн. (" +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .financialBKI.year
                                                    ) +
                                                    " рік) "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle.collapse-b",
                                            modifiers: { "collapse-b": true },
                                          },
                                        ],
                                        attrs: {
                                          block: "",
                                          variant: "success",
                                        },
                                      },
                                      [
                                        _vm._v("Дані податкової  "),
                                        _vm.chk_borg
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-exclamation-triangle",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-card-text",
                                  [
                                    _c(
                                      "b-collapse",
                                      {
                                        staticClass: "mt-2",
                                        attrs: { id: "collapse-b" },
                                      },
                                      [
                                        _c(
                                          "b-list-group",
                                          [
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_borg
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Податковий борг:"),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.debtorsBorgTAX.borg
                                                        .toString()
                                                        .replace(
                                                          /\B(?=(\d{3})+(?!\d))/g,
                                                          " "
                                                        )
                                                    ) +
                                                    " грн. (" +
                                                    _vm._s(
                                                      _vm._f("moment")(
                                                        _vm.rows.udata
                                                          .debtorsBorgTAX.period
                                                      )
                                                    ) +
                                                    ")\n                                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Реєстр платників акцизного податку з реалізації пального:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.excise_tax
                                                  ) +
                                                  "\n                                                "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v("Реєстр платників ПДВ:"),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.reestrPdv
                                                      .state
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.rows.udata.reestrPdv.ipn
                                                  ) +
                                                  "\n                                                "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Реєстр платників ПДВ статус:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata
                                                      .reestrPdvCancel.state
                                                  ) +
                                                  " (" +
                                                  _vm._s(
                                                    _vm.rows.udata
                                                      .reestrPdvCancel
                                                      .cancelDate
                                                  ) +
                                                  ")\n                                                "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Реєстр платників єдиного податку:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.reestrPed
                                                      .state
                                                  ) +
                                                  " (" +
                                                  _vm._s(
                                                    _vm.rows.udata.reestrPed
                                                      .cancelDate
                                                  ) +
                                                  ")\n                                                "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle.collapse-c",
                                            modifiers: { "collapse-c": true },
                                          },
                                        ],
                                        attrs: {
                                          block: "",
                                          variant: "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Фінансово-економічні показники"
                                        ),
                                        _vm.chk_fin
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-exclamation-triangle",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-card-text",
                                  [
                                    _c(
                                      "b-collapse",
                                      {
                                        staticClass: "mt-2",
                                        attrs: { id: "collapse-c" },
                                      },
                                      [
                                        _c(
                                          "b-list-group",
                                          [
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_net_income
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Виручка:"),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.financialBKI.net_income
                                                        .toString()
                                                        .replace(
                                                          /\B(?=(\d{3})+(?!\d))/g,
                                                          " "
                                                        )
                                                    ) +
                                                    " грн. (" +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .financialBKI.year
                                                    ) +
                                                    " рік)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_main_active
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Основні засоби:"),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.financialBKI.main_active
                                                        .toString()
                                                        .replace(
                                                          /\B(?=(\d{3})+(?!\d))/g,
                                                          " "
                                                        )
                                                    ) +
                                                    " грн. (" +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .financialBKI.year
                                                    ) +
                                                    " рік)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_net_profit
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Чистий прибуток:"),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.financialBKI.net_profit
                                                        .toString()
                                                        .replace(
                                                          /\B(?=(\d{3})+(?!\d))/g,
                                                          " "
                                                        )
                                                    ) +
                                                    " грн. (" +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .financialBKI.year
                                                    ) +
                                                    " рік)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    _vm.chk_current_liabilities
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Поточні зобов'язання:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.financialBKI.current_liabilities
                                                        .toString()
                                                        .replace(
                                                          /\B(?=(\d{3})+(?!\d))/g,
                                                          " "
                                                        )
                                                    ) +
                                                    " грн. (" +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .financialBKI.year
                                                    ) +
                                                    " рік)"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle.collapse-d",
                                            modifiers: { "collapse-d": true },
                                          },
                                        ],
                                        attrs: {
                                          block: "",
                                          variant: "success",
                                        },
                                      },
                                      [_vm._v("Майно")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-card-text",
                                  [
                                    _c(
                                      "b-collapse",
                                      {
                                        staticClass: "mt-2",
                                        attrs: { id: "collapse-d" },
                                      },
                                      [
                                        _c(
                                          "b-list-group",
                                          [
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Кількість об'єктів нерухомого майна у власності:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata.RealEstate
                                                  )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Кількість земельних ділянок у власності:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rows.udata
                                                      .realEstateRightsLand
                                                  )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("b-list-group-item", [
                                              _c("span", [
                                                _vm._v(
                                                  "Кількість ТЗ у власності:"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.rows.udata.vehicle)
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle.collapse-e",
                                            modifiers: { "collapse-e": true },
                                          },
                                        ],
                                        attrs: {
                                          block: "",
                                          variant: "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Судова історія та виконавчі провадження"
                                        ),
                                        _vm.chk_courts_enforcements
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-exclamation-triangle",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-card-text",
                                  [
                                    _c(
                                      "b-collapse",
                                      {
                                        staticClass: "mt-2",
                                        attrs: { id: "collapse-e" },
                                      },
                                      [
                                        _c(
                                          "b-list-group",
                                          [
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant: _vm.chk_courts
                                                    ? "warning"
                                                    : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість судових справ:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.Courts
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    Number(
                                                      _vm.rows.udata
                                                        .CourtsinProcess
                                                    ) > 0
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість судових справ в процесі:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .CourtsinProcess
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    Number(
                                                      _vm.rows.udata.CourtsDocs
                                                    ) > 0
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість судових документів:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata.CourtsDocs
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    Number(
                                                      _vm.rows.udata
                                                        .CourtsDocsDefendant
                                                    ) > 0
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість судових документів в якості відповідача:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .CourtsDocsDefendant
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    Number(
                                                      _vm.rows.udata
                                                        .CourtsDocsPlaintiff
                                                    ) > 0
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість судових документів в якості Позивача:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .CourtsDocsPlaintiff
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість судових документів за формою судочинства:"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.rows.udata
                                                    .listJusticeKindses,
                                                  function (item) {
                                                    return _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.name) +
                                                          " - " +
                                                          _vm._s(item.count)
                                                      ),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    Number(
                                                      _vm.rows.udata
                                                        .enforcementsOrgCountDebtor
                                                    ) > 0
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість виконавчих проваджень в якості боржника:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .enforcementsOrgCountDebtor
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                attrs: {
                                                  variant:
                                                    Number(
                                                      _vm.rows.udata
                                                        .enforcementsOrgCountCreditor
                                                    ) > 0
                                                      ? "warning"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Кількість виконавчих проваджень в якості cтягувача:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.rows.udata
                                                        .enforcementsOrgCountCreditor
                                                    )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c("ul", { staticClass: "list-group company_full_info" }, [
                  _c(
                    "li",
                    { staticClass: "list-group-item list-group-item-success" },
                    [_vm._v("Немає даних")]
                  ),
                ]),
            _vm._v(" "),
            _c("div"),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }